import { useMemo } from 'react';

import { PrimaryTab } from 'modules/common/components/PrimaryTab';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';
import { useUniformHeight } from 'modules/common/hooks/useUniformHeight';

import { AAPIAboutContent } from '../components/AAPIAboutContent';
import { AAPIPricingTable } from '../components/AAPIPricingTable';
import { AAPISupportedNetworks } from '../components/AAPISupportedNetworks';
import { aapiInfoTabsTranslation } from '../translation';
import { useAAPIInfoTabsStyles } from '../useAAPIInfoTabsStyles';

const TAB_CONTENT_SELECTOR = 'tab-content';

export const useAAPIInfoTabs = () => {
  const { classes } = useAAPIInfoTabsStyles();

  const { keys, t } = useTranslation(aapiInfoTabsTranslation);

  const maxHeight = useUniformHeight(`.${TAB_CONTENT_SELECTOR}`);

  return useMemo(
    () => [
      {
        id: 'about',
        title: (isSelected: boolean) => (
          <PrimaryTab
            className={classes.advancedApiPrimaryTab}
            isSelected={isSelected}
            label={t(keys.about)}
          />
        ),
        content: (
          <div
            style={{ minHeight: `${maxHeight}px` }}
            className={TAB_CONTENT_SELECTOR}
          >
            <AAPIAboutContent />
          </div>
        ),
      },
      {
        id: 'networks',
        title: (isSelected: boolean) => (
          <PrimaryTab
            className={classes.advancedApiPrimaryTab}
            isSelected={isSelected}
            label={t(keys.networks)}
          />
        ),
        content: (
          <div
            style={{ minHeight: `${maxHeight}px` }}
            className={TAB_CONTENT_SELECTOR}
          >
            <AAPISupportedNetworks />
          </div>
        ),
      },
      {
        id: 'pricing',
        title: (isSelected: boolean) => (
          <PrimaryTab
            className={classes.advancedApiPrimaryTab}
            isSelected={isSelected}
            label={t(keys.pricing)}
          />
        ),
        content: (
          <div
            style={{ minHeight: `${maxHeight}px` }}
            className={TAB_CONTENT_SELECTOR}
          >
            <AAPIPricingTable />
          </div>
        ),
      },
    ],
    [
      classes.advancedApiPrimaryTab,
      keys.about,
      keys.networks,
      keys.pricing,
      maxHeight,
      t,
    ],
  );
};
